import React, { Component } from 'react';
import { Select, Spin, Empty } from 'antd';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { OPTION_IDS } from '../../../constants/app-constants';
class Select2multiple extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            select2options: [],
            loading: false,
            selectdata: {},
            fetching: true
        };
    }
    componentDidMount() {
        this.setState((state) => ({ 'selectdata': this.props.selectdata, select2options: [], loading: true }), () => {
            if (this.props.selectdata.name === 'counsellor_id') {
                this.selectFetchCall();
            }
            if (this.props.selectdata.name === 'counsellor_type') {
                this.selectFetchCall();
            }
            if (this.props.selectdata.name === 'mapping_unit') {
                this.selectFetchCall();
            }
            if (this.props.selectdata.name === 'mapping_conselling_station') {
                this.selectFetchCall();
            }
            if (this.props.selectdata.name === 'mapping_doctor') {
                this.selectFetchCall();
            }
        });
        console.log(this.props.selectdata);

    }

    componentDidUpdate(prevProps, pervState) {
        if (prevProps.selectdata.value != this.props.selectdata.value) {
            this.setState((state) => ({ 'selectdata': this.props.selectdata }));
        }
    }

    handleChange(value) {
        console.log(`selected ${value}`);
    }

    onChange(value) {


        let { selectdata } = this.state;
        selectdata['value'] = value;


        // this.selectFetchCall();
        let text = null;

        this
            .state
            .select2options
            .map((data, key) => {
                if (data['id'] === value) {
                    text = data['name'];
                }
            });


        selectdata['text'] = text;
        this.setState((state) => ({ 'selectdata': selectdata }));
        if (this.props.selectdata.name === 'counsellor_id') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }


        else {
            this
                .props
                .onselectChanges({
                    id: this.props.selectdata.name,
                    text: text,
                    name: this.props.selectdata.name,
                    value: value,
                    parrentMode: this.props.selectdata.parrentMode,
                    parrentName: this.props.selectdata.parrentName
                });
        }

    }

    onBlur() {
        console.log('blur');
        console.log(this.props);
        // this.selectFetchCall(); this.selectFetchCall();
    }

    onFocus() {
        console.log('focus');
        this.setState({ select2options: [], loading: true });
        // //console.log(this.props);
        this.selectFetchCall();
    }

    onSearch(val) {
        console.log('search:', val);
    }

    selectFetchCall() {
        this.setState({ fetching: true });
        const {
            getActiveCounsellors,getCounsellingStationsDropDown,master_unit,getCounsellorTypes
        } = networkList;
        if (this.props.selectdata.name === 'counsellor_id') {
            postService(getActiveCounsellors, 'GET', 'null').then(res => {
                if (res) {
                    let newData = [];
                    res.data.map((userData, roomKey) => {
                            newData.push({
                                'id': userData['id'],
                                'name': userData['username']
                            })
                    })
                    this.setState((state) => ({ select2options: newData, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'counsellor_type') {
            postService(getCounsellorTypes, 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'payment') {
            var data = [
                {
                    'id': 1,
                    'name': 'Cash'
                }, {
                    'id': 2,
                    'name': 'Insurance'
                }
                , {
                    'id': 3,
                    'name': 'Corporate'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'mapping_unit' ) {
            postService('getUnitsall', 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'mapping_conselling_station' ) {
            let user_data = ''    
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                user_data = JSON.parse(localStorage.getItem('user_data'))
               } 
            postService('getCounsellingStationsDropDown', 'POST', { "unit_id": user_data['unitid'] }).then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'mapping_doctor' ) {
            let user_data = ''    
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                user_data = JSON.parse(localStorage.getItem('user_data'))
               } 
            postService('getDoctorsforDropdown', 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
    }

    getQueuevalue(name) {
        let { Queuedata } = this.props;
        let value = null;
        Queuedata.filter(data => {
            if (data['name'] === name && data['valid']) {

                value = data['value'];
            }
        })
        return value;
    }
    getFormvalue(name) {
        let { formData } = this.props;
        let value = null;
        formData.filter(data => {
            if (data['name'] === name && data['valid']) {

                value = data['value'];
            }
        })
        return value;
    }

    render() {
        const { fetching } = this.state;
        // console.clear();
        let mode = 'multiple';
        let defvalue = null;
        let valueText = this.state.selectdata.text ? this.state.selectdata.text : null;
        const Option = Select.Option;
        const children = [];
        if (this.state.select2options.length !== 0) {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id !== null) {
                        children.push(
                            <Option key={key} value={data.id}>{data.name
                                ? data.name
                                : data.value}</Option>
                        );
                    }

                });
        }
        if ((this.props.selectdata.name === 'counsellor_id' || this.props.selectdata.name === 'counsellor_type' || this.props.selectdata.name === 'mapping_unit' || this.props.selectdata.name === 'mapping_conselling_station' || this.props.selectdata.name === 'mapping_doctor')) {
            mode = 'multiple'
            defvalue = [];
            valueText = []
        }
        let selected_value = [];

        if (this.state.selectdata && this.state.selectdata['value'] && Array.isArray(this.state.selectdata['value'])) {
            this.state.selectdata['value'].map((data) => {
                if ((this.props.selectdata.name === 'counsellor_id')) {
                    this.state.select2options.map((mapping_unit, skey) => {
                        if ((data['counsellor_id'] && data['counsellor_id'] == mapping_unit['id']) || (data && data == mapping_unit['id'])) {
                            selected_value.push(mapping_unit['id']);
                            defvalue.push(mapping_unit['name']);
                        }
                    })
                }
                if ((this.props.selectdata.name === 'counsellor_type')) {
                    this.state.select2options.map((counsellor_types, skey) => {
                        if ((data['id'] && data['id'] === counsellor_types['id']) || (data && data === counsellor_types['id'])) {
                            selected_value.push(counsellor_types['id']);
                            defvalue.push(counsellor_types['name']);
                        }
                    })
                }
                if ((this.props.selectdata.name === 'payment')) {
                    this.state.select2options.map((payment_types, skey) => {
                        if ((data['id'] && data['id'] === payment_types['id']) || (data && data === payment_types['id'])) {
                            selected_value.push(payment_types['id']);
                            // defvalue.push(payment_types['name']);
                        }
                    })
                }
                if ((this.props.selectdata.name === 'mapping_unit')) {
                    this.state.select2options.map((mapping_unit, skey) => {
                        if ((data['id'] && data['id'] === mapping_unit['id']) || (data && data === mapping_unit['id'])) {
                            selected_value.push(mapping_unit['id']);
                            // defvalue.push(mapping_unit['name']);
                        }
                    })
                }
                if ((this.props.selectdata.name === 'mapping_conselling_station')) {
                    this.state.select2options.map((mapping_unit, skey) => {
                        if ((data['id'] && data['id'] === mapping_unit['id']) || (data && data === mapping_unit['id'])) {
                            selected_value.push(mapping_unit['id']);
                            // defvalue.push(mapping_unit['name']);
                        }
                    })
                }
                if ((this.props.selectdata.name === 'mapping_doctor')) {
                    this.state.select2options.map((mapping_unit, skey) => {
                        if ((data['id'] && data['id'] === mapping_unit['id']) || (data && data === mapping_unit['id'])) {
                            selected_value.push(mapping_unit['id']);
                            // defvalue.push(mapping_unit['name']);
                        }
                    })
                }
            })
        }
        return (
            <Select
                showSearch
                mode={mode}
                style={{
                    width: '100%'
                }}
                placeholder={this.state.selectdata.placeholder}
                defaultValue={defvalue}
                value={selected_value}
                optionFilterProp="children"
                onChange={this
                    .onChange
                    .bind(this)}
                onFocus={this
                    .onFocus
                    .bind(this)}
                onBlur={this
                    .onBlur
                    .bind(this)}
                notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                onSearch={this.onSearch}
                disabled={this.state.selectdata.disable}
                loading={false}
                // menuItemSelectedIcon={< Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                dropdownMatchSelectWidth={false}>
                {children}
            </Select>
        );
    }
}

export default Select2multiple;
